import { Routes, Route } from 'react-router-dom';
import { PERMISSOES_E_ROTAS } from '../config/permissoesRotas';

// Indicador
import Graficos from './Graficos';
import AjustarIndicadores from './AjustarIndicadores';
import InformarIndicadoresPlanilha from './InformarIndicadoresPlanilha';

// Pendências
import ResponderPendencias from './ResponderPendencias';
import AcompanharPendencias from './AcompanharPendencias';

// Relatórios
import GerarRelatorios from './GerarRelatorios';

// Admin & Configurações
import Home from './Home';
import PrivateRoute from './RotasPrivadas';
import TelaInformativa from './TelaInformativa';
import Configuracoes from './Configuracoes';

// Relatório de Acompanhamento
import CriaFormularioAcompanhamento from './CriaFormularioAcompanhamento';
import RelatoriosEnviados from './relatorioAcompanhamento/RelatoriosEnviados';
import VerificaRelatorio from './relatorioAcompanhamento/VerificaRelatorio';
import DownloadRelatorioAcompanhamento from './DownloadRelatorioAcompanhamento';

function Rotas() {

    console.log('### Iniciando ROTAS ###');

    return (
        <Routes>
            {/*------ Rodas publicas ------*/}

            <Route path='/'
                element={<Home />} />

            <Route path='/graficos'
                element={<Graficos />} />

            <Route path='/informativos'
                element={<TelaInformativa
                    cabecalho=''
                    mensagem=''
                    pathRedirect=''
                    buttonMessage=''
                    urlExterna={false} />}
            />

            {/*------ Rodas privadas ------*/}

            {/* INDICADOR */}

            <Route path='/indicador/informar-por-planilha'
                element={
                    <PrivateRoute acceptedRoles={PERMISSOES_E_ROTAS['informaIndicador']}>
                        <InformarIndicadoresPlanilha />
                    </PrivateRoute>}
            />

            <Route path='/indicador/ajustar'
                element={
                    <PrivateRoute acceptedRoles={PERMISSOES_E_ROTAS['ajustaIndicador']}>
                        <AjustarIndicadores />
                    </PrivateRoute>}
            />

            {/* RELATÓRIO DE ACOMPANHAMENTO */}

            <Route path='/relatorio-acompanhamento/criar'
                element={
                    <PrivateRoute acceptedRoles={PERMISSOES_E_ROTAS['criaRelAcomp']}>
                        <CriaFormularioAcompanhamento />
                    </PrivateRoute>}
            />

            {/* <Route path='/relatorio-acompanhamento/enviados'
                element={<PrivateRoute acceptedRoles={permissoesRotas['relAcompEnviados']}>
                    <RelatoriosEnviados />
                </PrivateRoute>}
            /> */}

            {/* <Route path='/relatorio-acompanhamento/verificacao/:relatorioAcompanhamentoId'
                element={<PrivateRoute acceptedRoles={PERMISSOES_E_ROTAS['relAcompEnviados']}>
                    <VerificaRelatorio />
                </PrivateRoute>}
            /> */}


            <Route path='relatorio-acompanhamento/download'
                element={
                    <PrivateRoute acceptedRoles={PERMISSOES_E_ROTAS['downloadRelAcomp']}>
                        <DownloadRelatorioAcompanhamento />
                    </PrivateRoute>}
            />

            {/* PENDÊNCIAS */}

            <Route path='/relatorio-acompanhamento/pendencias/responder'
                element={<PrivateRoute acceptedRoles={PERMISSOES_E_ROTAS['respondePendencia']}>
                    <ResponderPendencias />
                </PrivateRoute>}
            />

            {/* <Route path='/relatorio-acompanhamento/pendencias/acompanhar'
                element={<PrivateRoute acceptedRoles={PERMISSOES_E_ROTAS['acompanhaPendencias']}>
                    <AcompanharPendencias />
                </PrivateRoute>}
            /> */}

            {/* RELATÓRIOS */}

            <Route path='/relatorios/gerar'
                element={<PrivateRoute acceptedRoles={PERMISSOES_E_ROTAS['gerarRelatorios']}>
                    <GerarRelatorios />
                </PrivateRoute>}
            />

            {/* ADMIN */}

            <Route path='/admin/configuracoes-gerais'
                element={<PrivateRoute acceptedRoles={PERMISSOES_E_ROTAS['configuracoesGerais']}>
                    <Configuracoes />
                </PrivateRoute>}
            />

        </Routes>
    );
}

export default Rotas;
